import React, { useEffect } from 'react';
import withView from '../../../cmn/docAutomation/withView';

const DocGridXAxisRow = (props)=>{
    const {formObject, viewData, viewRow, rowKey, rowID, reloadSearch} = props

    const renderXAxisView = () => {
        let DynamicComponent = formObject.viewMap[viewRow.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vCMNGridLabel"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return <DynamicComponent formObject={formObject} viewData={viewData} rowKey={rowKey} 
            rowID={rowID} reloadSearch={reloadSearch}/>
        }
    }

    // console.log("viewData.rowValues", viewData.rowValues);

    return(
        <>{renderXAxisView()}</>
    )
}

const DocGridXAxisData = (props)=>{
    const {formObject, viewData, reloadSearch} = props

    const initialiseActions = () => {
        // console.log("custom action set", formObject.dataList);
        if(formObject.dataList) {
            formObject.initialiseCustomActions(formObject.dataList.actionName, 
                formObject.dataList.depActions);
        }
    }

    useEffect(initialiseActions, [props.viewData]);

    if(viewData){
        return(
            <div className="uiListTable uiHorizontalScroll" >
                <div className="uiXGridSearchHeading">
                    <ul className='uiXGridHeaderList uiCornerAll'>
                        {
                            Object.values(viewData).sort((a, b) => a.sortKey - b.sortKey).map((row, index)=>(
                                <li key={index} className='uiColumnCenter uiXGridHeaderCell uiXYGridXRowHeight uiXYGridXRowWidth'>
                                    <DocGridXAxisRow formObject={formObject} viewData={viewData} viewRow={row} rowKey={row.rowKey} rowID={row.dataList.dbRowId} reloadSearch={reloadSearch}></DocGridXAxisRow>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        )
    }
    else return null;
}

export default withView(DocGridXAxisData, '', '', 0);
